export default __webpack_public_path__ + "static/media/submitted.b2d7ee82.svg";